<template>
  <a-card>
    <div style="float: right;">
      <div class="table-toolbar">
        <a-button type="primary" @click="onEdit">
          <template #icon>
            <form-outlined />
          </template>
        </a-button>
      </div>
    </div>
    <div class="top">
      <div class="imgBox">
        <img-upload v-model:value="detail.headShot" :showBtn="false" disabled />
      </div>
      <div class="rightBox">
        <p class="name">{{ detail.name }}</p>
        <p class="second">{{ detail.sex == '0' ? '男' : '女' }}&nbsp; / {{ detail.age }}岁&nbsp; / {{ detail.yearsService
        }}年工作经验&nbsp; / <dict-render :dict-obj="dictObjs['education_background']" v-if="detail.educationBackground"
            :text="detail.educationBackground"></dict-render>
        </p>
        <p class="second">
          <mail-outlined />&nbsp; {{ detail.emailAddress }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <phone-outlined />&nbsp;
          {{ detail.phoneNumber }}
        </p>
      </div>
    </div>
    <a-descriptions bordered :column="2">
      <a-descriptions-item label="身份证号码">{{ detail.identityCardNumber }}</a-descriptions-item>
      <a-descriptions-item label="是否为应届生">{{ detail.freshGraduate == 0 ? '是' : '否' }}</a-descriptions-item>
      <a-descriptions-item label="出生日期">{{ detail.dateBirth ? detail.dateBirth.split(' ')[0] : '' }}</a-descriptions-item>
      <a-descriptions-item label="现居地">{{ detail.provject }}</a-descriptions-item>
      <a-descriptions-item label="参加工作时间">{{ detail.timeWork ? detail.timeWork.split(' ')[0] : ''
      }}</a-descriptions-item>
      <a-descriptions-item label="详细地址">{{ detail.detailedAddress }}</a-descriptions-item>
      <a-descriptions-item label="个人简介">{{ detail.personalProfile }}</a-descriptions-item>
    </a-descriptions>
  </a-card>
  <UserModal ref="userModal" :form-primary-key-field="listKeyField" @finish="getInfo"/>
</template>

<script>
import { dictMixin } from "@/mixins";
import UserModal from './components/UserModal';
import { personalCenterInfo } from "@/api/educationService";
import DictRender from "@/components/other/DictRender";
import { showCity } from "@/utils/util";

export default {
  name: "index",
  mixins: [dictMixin],
  components: {
    UserModal, DictRender
  },
  data() {
    return {
      dictNames: 'education_background',
      detail: {},
      listKeyField: "id",
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.getAction({
        url: personalCenterInfo.userDetail
      }).then(res => {
        this.detail = {
          ...res,
          provject: showCity(res.prov, res.city, res.dist)
        }
      })
    },
    onEdit() {
      this.getAction({
        url: personalCenterInfo.detail
      }).then(res => {
        this.onShowModal('userModal', res);
      })
    },
    onShowModal(refName, data = {}) {
      const refEle = this.$refs[refName];
      refEle.form = Object.assign({}, data);
      refEle.visible = true;
    },
  }
}
</script>

<style scoped lang="less">
.top {
  overflow: hidden;

  .imgBox {
    float: left;
    margin-right: 20px;
  }

  .rightBox {
    float: left;
    color: #333;

    .name {
      font-weight: 700;
      font-size: 24px;
    }

    .second {
      font-size: 12px;
      margin-top: 10px;
    }
  }
}
</style>
